import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { AddStaffPageNumber } from "src/app/enums/express-add-staff-page-number.enum";

@Component({
  selector: "app-add-staff-info",
  templateUrl: "./add-staff-info.component.html",
  styleUrls: ["./add-staff-info.component.scss"],
})
export class AddStaffInfoComponent implements OnInit {
  @Input() renderAddStaff: number;
  @Output() validState: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() addStaff: EventEmitter<number> = new EventEmitter<number>();

  renderComponent: FormControl;

  public readonly ADD_STAFF_PAGE_NUMBER = AddStaffPageNumber;

  constructor() { }

  ngOnInit(): void {
    this.renderComponent = new FormControl(this.renderAddStaff ?
      this.renderAddStaff : this.ADD_STAFF_PAGE_NUMBER.manualAddStaffPage);
  }

  /**
   * Switch to manual or csv add staff based on radio selection
   */
  manualOrCsvAddStaff(): void {
    this.addStaff.emit(this.renderComponent.value);
  }
}
